import React from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import MainStore from '../../../MainStore';
import WorkStore from '../Kanban/WorkStore';
import AuthStore from '../../Auth/AuthStore';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/AddCircleOutline';

export default class ProjectStages extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stages: []
        };
        this.handleChange = this.handleChange.bind(this);
        this.loadStages = this.loadStages.bind(this);
        this.saveStages = this.saveStages.bind(this);
    }

    componentDidMount() {
        this.loadStages();
    }

    handleChange = (name, id) => evt => {
        var stages = this.state.stages.slice(0);
        var stageIndex = stages.findIndex(s => s.id === id);
        stages[stageIndex][name] = evt.target.value;
        this.setState({ stages: stages, isChanged: true });
    }

    loadStages() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Project/GetProjectStages?isReturnFact=true&id=' + this.props.projectId , {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ stages: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    saveStages() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Project/SaveProjectStages', {
            method: 'POST',
            body: JSON.stringify(this.state.stages),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ isChanged: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    formatDate(d) {
        var date = new Date(d);
        var month = (date.getMonth() + 1);
        if (month < 10) month = '0' + month;

        var day = date.getDate();
        if (day < 10) day = '0' + day;

        return date.getFullYear() + '-' + month + '-' + day;
    }

    handleWorkAdd = (stageId, stageName) => () => {
        var work =
        {
            caption: stageName + ' ',
            sp: -1,
            assigneeId: AuthStore.getUserId,
            assignee: AuthStore.getUser.fullName,
            assigneeRoleId: AuthStore.getUser.roleId,
            projectId: MainStore.openedProject.id,
            projectName: MainStore.openedProject.name,
            stage: stageName,
            stageId: stageId,
            account: MainStore.openedProject.account,
            accountId: MainStore.openedProject.accountId
        };
        WorkStore.openWorkDialog(work);
    }

    render() {
        return (
            <div>
                {this.state.stages.map(s => <div>
                    <div className="clearfix stage-row">
                        <div className="stage-cell caption">{s.name}</div>
                        <div className="stage-cell">
                            <TextField required
                                id="standard-required"
                                label="План. часы"
                                fullWidth
                                margin="normal"
                                value={s.planHours}
                                type="number"
                                onChange={this.handleChange('planHours', s.id)}
                            />
                        </div>
                        <div className="stage-cell">
                            <TextField required
                                id="standard-required"
                                label="Клиентские. часы"
                                fullWidth
                                margin="normal"
                                type="number"
                                value={s.clientHours}
                                onChange={this.handleChange('clientHours', s.id)}
                            />
                        </div>
                        <div className="stage-cell date">
                            <TextField
                                id="date"
                                label="Дата начала"
                                type="date"
                                margin="normal"
                                value={this.formatDate(s.start)}
                                onChange={this.handleChange('start', s.id)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                        <div className="stage-cell date">
                            <TextField
                                id="date"
                                label="Дата завершения"
                                margin="normal"
                                type="date"
                                value={this.formatDate(s.end)}
                                onChange={this.handleChange('end', s.id)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                        <div className="stage-cell">
                            Факт: {s.fact.toFixed(2)}ч
                        </div>
                        <Tooltip title="Создать задачу">
                            <IconButton
                                onClick={this.handleWorkAdd(s.id, s.name)}
                                className="sale-card-add-work-button"
                                size="large">
                                <AddIcon style={{ fill: "red" }} />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className="stage-comment-row">
                        <TextField required
                            id="standard-required"
                            label="Комментарий"
                            fullWidth
                            margin="normal"
                            value={s.comment}
                            multiline
                            onChange={this.handleChange('comment', s.id)}
                        />
                    </div>
                 </div>)}
                {this.state.isChanged && <IconButton onClick={this.saveStages} size="large">
                    <SaveIcon />
                </IconButton>}
            </div>
        );
    }
}
